// extracted by mini-css-extract-plugin
module.exports = {"content":"switch-mode_content__jPIhS","toggle":"switch-mode_toggle__1lJh1","slider":"switch-mode_slider__IfaQc","hideText":"switch-mode_hideText__2wWpK"};